/*
 * @Author: ze.wang@diact.com
 * @Date: 2022-11-24 15:08:10
 * @Function: Please Input Function
 */
import { quSave } from '@/service/question'
import iconSrc from '@/assets/images/edit/config/ico-title@2x.png'
export default {
  orderById: 40,
  elementType: 'MusicBox',
  elementDesc: '语音题',
  type: 'musicbox',
  // 是否可配置
  config: true,
  title: '语音题',
  placeholder: '请直接输入或点击语音答题',
  tipsMaxSubmit: '最多提交5条语音',
  tipsMusicStart: '点击开始答题',
  tipsMusicAnswering: '正在答题',
  tipsMusicEnd: '点击结束录音',
  tipsRecordTime: '录音时间太短',
  tipsUseEvn: '仅在手机H5打开时可以使用语音方式答题',
  tipsNoSupport: '您的浏览器不支持音频播放',
  isRequired: '1',
  value: [],
  ruleError: '该字段不能为空',
  saveUrl: '/design/qu-music/ajaxSave.do',
  iconStyle: {
    width: '11px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
    }, this)
  },
  saveCb (data) {
    
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      quId: this.id,
      answer: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/MusicBox/config.js